import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import useSWR from 'swr';
import { getApi3Endpoint } from '../utils/links.es.js';
import { SwrFetcher } from '../utils/swr.es.js';
import { usePricingContext } from '../contexts/PricingProvider/PricingContext.es.js';
import { EventIds } from '../constants/EventIds.es.js';

var timezoneOffset = new Date(Date.now()).getTimezoneOffset();
var getCatalogSalePath = function getCatalogSalePath(props) {
  var path = "/subscription/api/v1/catalog/sale?timezoneOffset=".concat(timezoneOffset);
  if ((props === null || props === void 0 ? void 0 : props.includePrismicContent) && (props === null || props === void 0 ? void 0 : props.language)) {
    path += "&includePrismicContent=true&language=".concat(props.language);
  }
  return path;
};

/**
 * Fetch sale for (all) serviceOffers.
 * */
var useCatalogSale = function useCatalogSale(props) {
  var _usePricingContext = usePricingContext(),
    env = _usePricingContext.env,
    log = _usePricingContext.log,
    authorizationToken = _usePricingContext.authorizationToken;
  var _useSWR = useSWR([getApi3Endpoint(env, getCatalogSalePath(props)), authorizationToken], SwrFetcher, {
      revalidateOnFocus: false,
      onError: function onError(error) {
        var status = error === null || error === void 0 ? void 0 : error.status;

        // BE will return 404 when they have no active sale to return
        if (status !== 404) {
          log.error('Unable to fetch sale catalog', EventIds.CatalogSaleFail, error, _objectSpread({}, status));
        }
      },
      onErrorRetry: function onErrorRetry(error) {
        // Never retry on 404.
        if (error.status === 404) {
          return;
        }
      }
    }),
    data = _useSWR.data,
    error = _useSWR.error;
  var loading = !error && !data;
  return {
    data: data,
    loading: loading,
    error: error
  };
};

export { getCatalogSalePath, useCatalogSale };
